import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Phone';

class PhoneIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default PhoneIcon;
